import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';
import Button from 'react-bootstrap/Button';
import FormControl from 'react-bootstrap/FormControl';
import { z } from 'zod';

import { numericId, validate } from '../../utils/validation';
import FieldError from '../field-error';

export const TableSearch = (props) => {
    //@TODO FormControl should be replaced with components/text-input
    const [error, setError] = useState();
    const [submitted, setSubmitted] = useState(false);
    const schema = useMemo(() => z.object({ id: numericId(`${props.name} Id`) }), [props.name]);
    const errorId = `${props.name}-search-error`;

    useEffect(() => {
        if (submitted) {
            setError(validate(schema, { id: props.value }).errors.id);
        }
    }, [schema, submitted, props.value]);

    const handleSearch = () => {
        const { valid, errors } = validate(schema, { id: props.value });

        setSubmitted(true);
        setError(errors.id);

        if (valid) {
            props.handleSubmit();
        }
    };

    return (
        <div>
            <h3>Search based on {props.name} Id</h3>
            <FormControl
                type="text"
                placeholder={props.name + ' Id'}
                onChange={props.handleChange}
                value={props.value}
                isInvalid={!!error}
                {...(error && { 'aria-invalid': 'true', 'aria-describedby': errorId })}
            />
            <FieldError id={errorId} error={error} />
            <Button variant="primary" onClick={handleSearch}>
                Load {props.name}
            </Button>
        </div>
    );
};

TableSearch.propTypes = {
    name: PropTypes.string,
    handleChange: PropTypes.func,
    handleSubmit: PropTypes.func,
    value: PropTypes.string,
};
